import React from 'react'
import { Backdrop, Box, CircularProgress, Stack, Typography } from '@mui/material'
import { appColors } from "../../constants/theme";

const Loading = ({ backdrop = false, minHeight = "60vh", message }) => {
    if (!backdrop) {
        return (
            <Box
                sx={{
                    width: "100%",
                    minHeight,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: appColors.info,
                }}
            >
                <Stack alignItems="center" spacing={2}>
                    <CircularProgress color="inherit" />
                    {message ? (
                        <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ maxWidth: 360, px: 2 }}>
                            {message}
                        </Typography>
                    ) : null}
                </Stack>
            </Box>
        );
    }

    return (
        <Backdrop
            open={true}
            sx={{
                color: appColors.info,
                zIndex: (theme) => theme.zIndex.modal + 2,
                position: "fixed",
                backgroundColor: "rgba(255, 255, 255, 0.92)",
                backdropFilter: "blur(10px)",
            }}>
            <Stack alignItems="center" spacing={2.5} sx={{ px: 3 }}>
                <CircularProgress color="primary" size={48} />
                {message ? (
                    <Typography variant="body1" color="text.primary" textAlign="center" sx={{ maxWidth: 400, fontWeight: 500 }}>
                        {message}
                    </Typography>
                ) : null}
            </Stack>
        </Backdrop>
    )
}

export const LoadingInline = () => {
    return (
        <Box sx={{ flex: 1, display: 'flex' }}>
            <CircularProgress color='inherit' />
        </Box>
    )
}

export default Loading